function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 23,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4904 30.7533C15.1581 30.3122 15.2462 29.6852 15.6872 29.3528C16.1283 29.0204 16.7553 29.1085 17.0877 29.5496L15.4904 30.7533ZM30.5816 29.6092C30.881 29.1452 31.5 29.0117 31.964 29.3112C32.4281 29.6107 32.5615 30.2296 32.262 30.6937L30.5816 29.6092ZM17.0877 29.5496C19.0532 32.1579 21.5934 33.4754 23.9988 33.5221C26.3789 33.5683 28.7969 32.3748 30.5816 29.6092L32.262 30.6937C30.1478 33.97 27.1142 35.5829 23.96 35.5217C20.8311 35.461 17.7544 33.7576 15.4904 30.7533L17.0877 29.5496Z",
  fill: "currentColor"
});

function SvgSmiley4Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley4Icon);
export default __webpack_public_path__ + "static/media/Smiley4Icon.d82da9e5.svg";
export { ForwardRef as ReactComponent };